import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {getNextStep} from '../actions/users';
import Main from '../components/Main.js';

const mapDispatchToProps = (dispatch) => {
    return {
        requestNextStep() {
            dispatch(getNextStep()).then((result) => {
                if (typeof(result.payload.data.endpoint) !== 'undefined') {
                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                    browserHistory.push({
                        pathname: result.payload.data.endpoint,
                    });
                }
            });
        },
    }
}

export default connect(null, mapDispatchToProps)(Main);


/** WEBPACK FOOTER **
 ** ./src/containers/MainContainer.js
 **/